const APPLICATION_STATUSES = {
  INCOMPLETE: 'appl_status_incomplete',
  SUBMITTED: 'appl_status_submitted',
  ACCEPTED: 'appl_status_accepted',
  REJECTED: 'appl_status_rejected',
}

export { APPLICATION_STATUSES }
